import { COLORS } from '@repo/design-system/index'
import { QIcon_close_default } from '@repo/icons/index'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { useConversationEditUserSetting } from '../../../../modules/apis/student/conversation'

interface AITutorialProps {
  hideTutorial: boolean
  setHideTutorial: any
  locale: string
}

const AITutorTutorial = ({ hideTutorial, setHideTutorial, locale }: AITutorialProps) => {
  const [step, setStep] = useState(1)
  const { mutate: edit } = useConversationEditUserSetting()

  const onClickClose = () => {
    edit(
      { key: 'hide_ai_tutor_tutorial', value: true },
      {
        onSuccess: () => {
          setHideTutorial(true)
          setStep(1)
        },
      }
    )
  }

  const onClickNext = () => {
    if (step === 4) {
      onClickClose()
    } else {
      setStep((prev) => prev + 1)
    }
  }

  useEffect(() => {
    if (hideTutorial) {
      window?.ReactNativeWebView?.postMessage(JSON.stringify({ type: 'SHOW_TAB_BAR' }))
    } else {
      window?.ReactNativeWebView?.postMessage(JSON.stringify({ type: 'HIDE_TAB_BAR' }))
    }
  }, [hideTutorial])

  if (hideTutorial) {
    return null
  }

  return (
    <div className="h-screen w-screen fixed left-0 top-0 z-100 bg-black bg-opacity-80 inset-0 " onClick={onClickNext}>
      <div className="p-[24px] flex flex-col h-full w-full">
        <div className="absolute right-24 top-24" onClick={onClickClose}>
          <QIcon_close_default width={24} height={24} color={COLORS.WHITE} />
        </div>
        <div
          className={classNames(
            'flex h-full',
            step === 3
              ? 'w-[80%] items-start pt-[24px]'
              : step === 1
              ? 'justify-center items-start pt-[120px] w-full'
              : 'justify-center items-center w-full '
          )}
        >
          <img
            src={`/assets/img/icons/ai_tutor_tutorial_screen_${step}_${locale}.svg`}
            className="w-full max-w-[640px] mx-auto h-auto"
            alt="Tutorial Screen"
          />
        </div>
      </div>
    </div>
  )
}

export default AITutorTutorial
